import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import {
	AsyncHorizontalOperationsNav,
	LazyHorizontalOperationsNav,
} from '@jira/navigation-apps__horizontal-nav-jsm-operations-container/src/async.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { LazyTeamDashboardSidebar } from '@jira/navigation-apps__sidebar-eoc-team-dashboard/src/async.tsx';
import { opsTeamLayout } from '@jira/platform__layouts-ops-team-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocOnCallRoute } from '@jira/router-routes__eoc-on-call-routes/src/eocOnCallRoute.tsx';
import { resources as teamDashboardResources } from '@atlassian/eoc-team-dashboard/resources';
import { resources as onCallResources } from '@atlassian/eoc-on-call/resources';
import type { Route, RouteResources } from '@atlassian/react-resource-router';
import OnCall, { LazyOnCall } from './ui/spa/eoc/on-call/index.tsx';

export const eocOnCallRouteEntry: Route = createEntry(eocOnCallRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: OnCall,
	layout: opsTeamLayout,

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	resources: [
		...getNavigationResources(),
		...teamDashboardResources(),
		...onCallResources(),
		getConsolidationStateResource(),
	] as RouteResources,

	navigation: {
		menuId: MenuIdPeople,
		horizontal: AsyncHorizontalOperationsNav,
	},

	forPaint: [
		LazyHorizontalOperationsNav,
		LazyAtlassianNavigation,
		LazyOnCall,
		LazyTeamDashboardSidebar,
	],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
